import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export function OnboardingLoad_Promotion({
  version = "promotion",
}: {
  version?: string; // v5...
}) {
  const navigate = useNavigate();

  useEffect(() => {
    navigate(`/${version}-onboarding/start/1`, { replace: true });
  }, []);

  // 로딩 중이거나 리다이렉트 전에는 아무것도 렌더링하지 않습니다.
  return <></>;
}
